export default "__VITE_ASSET__AWrDI6Wa__"